import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import SurroundingsPropertyGroup from '../../../components/PropertyGroup/SurroundingsPropertyGroup';
import ListingSection from '../ListingSection';
import ListingSectionItem from '../ListingSectionItem';

/**
 * This component is used to render the surroundings section of the listing page.
 * @param {object} props
 * @param {object} props.options - Options for the surroundings property group.
 * @param {Array<string>} props.surroundings - Selected surroundings.
 * @returns {React.JSX.Element|null}
 */

const SectionSurroundingsMaybeComponent = ({ options, surroundings = [] }) => {
  // Simplify retrieval of selectedOptions and check for null or empty array early.
  const selectedOptions = surroundings ?? [];
  if (selectedOptions.length === 0) {
    return null;
  }

  return (
    <ListingSection>
      <ListingSectionItem
        params={{
          sx: { justifyContent: { xs: 'center', md: 'flex-start' } },
        }}
      >
        <Typography
          component="h3"
          mb={2}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
          variant="h4"
        >
          <FormattedMessage id="ListingPage.surroundingsTitle" />
        </Typography>
      </ListingSectionItem>
      <ListingSectionItem
        params={{
          sx: { textAlign: { xs: 'center', md: 'left' } },
        }}
      >
        <SurroundingsPropertyGroup
          options={options}
          selectedOptions={selectedOptions}
          showNotSelectedItems={false}
          twoColumns={true}
        />
      </ListingSectionItem>
    </ListingSection>
  );
};

SectionSurroundingsMaybeComponent.displayName = 'SectionSurroundingsMaybe';

const SectionSurroundingsMaybe = memo(SectionSurroundingsMaybeComponent);

export default SectionSurroundingsMaybe;
